import { makeStyles } from '@mui/styles'
const useStyleOrganization = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    marginLeft: '5%',
    color: '#4B4952',
    paddingTop: '0.5rem'
  },
  icon: {
    fontSize: '2.2em',
    color: '#028B7E'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },

  typography: {
    fontSize: '1rem',
    paddingLeft: '0.2rem'
  },
  containerBody: {
    background: '#f9f9f9',
    width: '90%',
    marginLeft: '5%',
    marginTop: '1rem',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10
  },

  boxButtons: {
    display: 'flex',
    width: '95%',
    paddingTop: 10,
    marginLeft: 10
  },
  boxTable: { paddingTop: 10 },
  buttonAdd: {
    marginLeft: '2%',
    height: '30px',
    width: '95px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f2f2f2',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#fff'
    },
    border: '2px solid #028B7E',
    borderRadius: '23px'
  },
  addIconButton: {
    width: 12,
    height: 12,
    paddingLeft: 5,
    color: '#028B7E'
  },
  typographyButton: {
    paddingLeft: 5,
    fontFamily: 'Raleway',
    fontSize: 14.5,
    letterSpacing: '0.05em',
    color: '#028B7E'
  }
}))

export default useStyleOrganization
